// Sign-in words and the "your session ended" hand-off, kept in one place.

// One message for every wrong email or password: it never tells anyone which
// emails have a staff account (QA F06).
export const SIGN_IN_FAILED = "That email and password don’t match. Check them, or reset your password.";
export const ACCOUNT_OFF = "This account is switched off. Ask an admin to turn it back on.";
export const SESSION_ENDED = "Your session ended. Sign in again to continue.";

const NOTICE_KEY = "safrati.cms.sessionEnded";

// What the sign-in form says when the attempt fails. Any 4xx is a wrong
// email or password, worded the same way; the server's text is never shown.
export function signInError(err) {
  const status = err?.status ?? err?.response?.status ?? null;
  if (status === null || status === undefined) return "We couldn’t reach Safrati. Check your connection and try again.";
  if (status === 429) return "Too many tries. Wait a minute, then try again.";
  if (status >= 500) return "Signing in isn’t working right now. Try again in a minute.";
  // The API names a switched-off account only after a right password.
  if (/inactive/i.test(String(err?.message ?? err?.response?.data?.message ?? ""))) return ACCOUNT_OFF;
  return SIGN_IN_FAILED;
}

// Only a page inside the CMS: never another site, never the sign-in pages.
export function safeNext(next) {
  if (typeof next !== "string" || !next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return null;
  // Browsers drop tabs and line breaks from an address, so "/\t/site.com"
  // would become "//site.com": no spaces or control characters at all.
  if (/[\s\u0000-\u001f\u007f\\]/.test(next)) return null;
  if (next.startsWith("/auth/")) return null;
  return next;
}

// The sign-in address that brings the person back to where they were.
export function loginPath(from) {
  const next = safeNext(from);
  return next && next !== "/" ? `/auth/login?next=${encodeURIComponent(next)}` : "/auth/login";
}

export function rememberSessionEnded() {
  try {
    sessionStorage.setItem(NOTICE_KEY, "1");
  } catch {
    /* storage blocked: the sign-in page simply shows no notice */
  }
}

export function sessionEndedNotice() {
  try {
    return sessionStorage.getItem(NOTICE_KEY) === "1";
  } catch {
    return false;
  }
}

// The notice shows on the sign-in page that follows, not on later visits.
export function clearSessionEnded() {
  try {
    sessionStorage.removeItem(NOTICE_KEY);
  } catch {
    /* nothing to clear */
  }
}
